
import * as account                  from './account';
import * as appsettings              from './appsettings';
import * as breadcrumb               from './breadcrumb'; 
import * as communication            from './communication';    
import * as dialog                   from './dialog';
import * as fileDownload             from './fileDownload';
import * as form                     from './form';
import * as googlemaps               from './googlemaps';
import * as grid                     from './grid';
import * as header                   from './header';
import * as helpers                  from './helpers';
import * as inputs                   from './inputs';
import * as listbox                  from './listbox';
import * as main                     from './main';
import * as navigation               from './navigation';
import * as selection_navigation_bar from './selection_navigation_bar';
import * as session                  from './session';
import * as tabguard                 from './tabguard';
import * as tabstrip                 from './tabstrip';
import * as timeinterval             from './timeinterval';
import * as translatedLabels         from './translatedLabels';
import * as validation               from './validation';
import * as viewmode                 from './viewmode';

import * as OverrideKendoBehaviour   from '../../js/pre-com/overrideKendoBehaviour';



// _aggregates
import * as Modules                  from './modules/_aggregate';

export {
    account, appsettings, breadcrumb, communication, dialog, fileDownload, form,
    googlemaps, grid, header, helpers, inputs, listbox, main, navigation, selection_navigation_bar,
    session, tabstrip, timeinterval, translatedLabels, validation, viewmode,
    OverrideKendoBehaviour,

    Modules
}

// On document load
$(function () { 
    main.setupAjax();
    tabguard.initialize();
    OverrideKendoBehaviour.overrideKendoBehaviour();
});
